function isEmailAllowed(email){
    const emailsAllowed = ["vanshitaa@keystoneuniverse.com","akshashah@yellowspot.com","amitboliwal@yellowspot.com"];
    return emailsAllowed.includes(email);
}

export default isEmailAllowed;